export default function getResource(label, vars = []) {
    const resources = {
        addAllToBasket: 'Tout ajouter au panier',
        addAllToBasketAria: `Add All to Basket, ${vars[0]} ${vars[0] === 1 ? 'item' : 'items'}`,
        addAllToBasketLoading: 'Adding items to your basket',
        atbErrorTitle: 'Error',
        atbErrorMessage: 'Something went wrong on our end. None of these items were added to your basket. Please try again.',
        atbErrorOk: 'OK',
        change: 'Modifier',
        currentProduct: 'Article actuel',
        estimatedPrice: 'Prix estimé:',
        frequentlyBoughtTogether: 'Souvent achetés ensemble',
        bundleProductOptions: 'Regrouper les options de produits',
        chooseBundleOptions: 'Choose Bundle Options',
        viewDetails: 'View Details',
        chooseSelection: 'Choose Selection',
        noOptionsAvailable: 'This item has no options available to edit.'
    };
    return resources[label];
}
